import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Stack } from '@famly/mf_layout_stack';
import { Box } from '@famly/mf_layout_box';
import { Initials } from './initials';
export const IMAGE_PROPS = {
    sm: { size: '64px', borderRadius: '16px' },
    md: { size: '80px', borderRadius: '20px' },
    lg: { size: '96px', borderRadius: '24px' },
    xl: { size: '108px', borderRadius: '32px' },
};
const StyledImage = styled.img `
    width: 100%;
    border-radius: ${props => props.borderRadius};
    overflow: hidden;
`;
const Overlay = () => {
    return _jsx(Box, { position: "absolute", backgroundColor: "n500", opacity: 0.3, height: "100%", width: "100%" });
};
export const PersonImage = ({ image, initials, hasOverlay, size = 'md' }) => {
    return (_jsxs(Stack, { position: "relative", width: IMAGE_PROPS[size].size, height: IMAGE_PROPS[size].size, flexShrink: 0, borderRadius: IMAGE_PROPS[size].borderRadius, overflow: "hidden", children: [hasOverlay && _jsx(Overlay, {}), image ? (_jsx(StyledImage, { src: image })) : (_jsx(Initials, { compact: size === 'sm' || size === 'md', initials: initials, wrapperProps: {
                    borderRadius: IMAGE_PROPS[size].borderRadius,
                } }))] }));
};
